module.exports = __webpack_public_path__ + "img/9.8670483.webp";